/**
 * Utilitaires pour la manipulation des dates dans l'application Astreintes
 * 
 * IMPORTANT : Dans cette application, les astreintes sont toujours du vendredi au jeudi suivant.
 * Les dates sont stockées en base de données au format YYYY-MM-DD (sans timezone).
 */

/**
 * Formate une date locale en YYYY-MM-DD sans conversion UTC
 * 
 * ATTENTION : Ne pas utiliser .toISOString().split('T')[0] car cela convertit la date
 * en UTC et peut causer un décalage d'un jour selon le fuseau horaire.
 * 
 * @param {Date} date - La date à formatter (objet Date en heure locale)
 * @returns {string} - La date au format YYYY-MM-DD (ex: "2026-01-03")
 */
export const formatLocalDateToISO = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error('Invalid date object');
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

/**
 * Parse une date ISO (YYYY-MM-DD) en objet Date local
 * 
 * @param {string} dateStr - La date au format YYYY-MM-DD
 * @returns {Date} - Objet Date en heure locale
 */
export const parseISODateToLocal = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Vérifie si deux dates sont le même jour
 * 
 * @param {Date} date1 - Première date
 * @param {Date} date2 - Deuxième date
 * @returns {boolean} - true si les dates sont le même jour
 */
export const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

/**
 * Crée une date à midi pour éviter les problèmes de fuseau horaire
 * Utile lors de la manipulation de dates sans heure spécifique
 * 
 * @param {number} year - Année
 * @param {number} month - Mois (1-12)
 * @param {number} day - Jour
 * @returns {Date} - Date à 12:00:00 en heure locale
 */
export const createDateAtNoon = (year, month, day) => {
  return new Date(year, month - 1, day, 12, 0, 0, 0);
};





